import type { Action, Maybe } from 'src/types';
import type * as Schema from 'src/types/graphql';

export enum Actions {
  UPDATE_SKILLS_START = 'UPDATE_SKILLS_START',
  UPDATE_SKILLS_SUCCESS = 'UPDATE_SKILLS_SUCCESS',
  UPDATE_SKILLS_FAILURE = 'UPDATE_SKILLS_FAILURE',
}

export type SkillsAction =
  | (Action<Actions.UPDATE_SKILLS_START> & {
      payload: { skills: Schema.Skill[]; suggestedSkillsAdded: Maybe<number> };
    })
  | Action<Actions.UPDATE_SKILLS_SUCCESS>
  | (Action<Actions.UPDATE_SKILLS_FAILURE> & {
      payload: Error;
    });
